import React, { useState } from "react";
import Avatar, { genConfig } from 'react-nice-avatar'
import { IconArrowLeft, IconPlayerPlay } from "@tabler/icons-react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Button } from "@/components/ui/button"
import DetailCard from "@/components/agentpage/DetailCard"
import LargeText from "@/components/agentpage/LargeText";
import Content from "@/components/agentpage/Content";
import SubCard from "@/components/agentpage/SubCard";
import { Badge } from "@/components/ui/badge"
import {
	Tooltip,
	TooltipContent,
	TooltipProvider,
	TooltipTrigger,
  } from "@/components/ui/tooltip"

import { Edit2Icon } from "lucide-react";
import NameCard from "@/components/agentpage/NameCard";


export default function ViewAgentDetail() {
	const location = useLocation()
	const navigate = useNavigate()
	const { id } = useParams();
	const agent = JSON.parse(location?.state?.agent);
	const data = location?.state?.data


	const config = genConfig(agent?.agentProfile?.title);
	const [isFlow, setIsFlow] = useState(false);



	const EditAgent = (agent: any) => {
		navigate(`/addagents/${id}`, { state: { agent } });
	};

	const UseAgent = () => {
		const { id, raw_data } = data;
		navigate(`/useAgent/${id}`, { state: { agent: raw_data } });
	};

	const handleCloseDialog = () => {
		setIsFlow(!isFlow)
	}

	return (
		<>
			<div className="flex flex-col gap-4 w-full bg-gray-50 mb-6">

				<div className="w-full pt-8 pb-4 px-8">
					<div className="flex items-center justify-between">
						<Button
							title='Home'
							variant="ghost"
							size="sm"
							className="flex items-center justify-center"
							onClick={() => navigate('/')}
						>
							<IconArrowLeft stroke={1.5} size='1.3rem' />
						</Button>
						<div className="flex items-center justify-between flex-grow ml-4">
							<div className="flex items-center">
								<Avatar style={{ width: '4rem', height: '4rem' }} {...config} />
								<div className="ml-4">
									<h2 className="text-2xl font-bold">{agent?.agentProfile?.title}</h2>
									<p className="text-sm text-gray-600">{agent?.agentProfile?.description}</p>
								</div>
							</div>
							<div className="flex gap-2">
								<Button
									title='Edit'
									variant="outline"
									size="sm"
									className="flex items-center justify-center"
									onClick={() => EditAgent(agent)}
								>
									<Edit2Icon size={16} strokeWidth={1.5} className="text-muted-foreground" />
									<span className="ml-1">Edit</span>
								</Button>
								<Button
									title='Run'
									variant="default"
									size="sm"
									className="flex items-center justify-center"
									onClick={() => UseAgent()}
								>
									<IconPlayerPlay size={16} stroke={1.5} className="text-muted-foreground" />
									<span className="ml-1">Run</span>
								</Button>
							</div>
						</div>
					</div>
				</div>
				<div className="flex gap-4 w-full px-8">
					<div className="w-1/4">
						<DetailCard title="Welcome Message" subtitle="This is Subtitle">
							<LargeText text={agent?.settings?.welcomeMessage}></LargeText>
						</DetailCard>

						<DetailCard title="Core Instruction" subtitle="This is Subtitle">
							<LargeText text={agent?.coreInstruction}></LargeText>
						</DetailCard>

						<DetailCard title="Default Prompt" subtitle="This is Subtitle">
							<LargeText text={agent?.settings?.parentPrompt}></LargeText>
						</DetailCard>

						<DetailCard title="Language Model" subtitle="Every  agent is powered by LLM that handles reasoning and communication. This defaults to GPT 3.5 if not set.">
							<select id="small" className="block w-full p-2 mt-2 text-sm text-gray-900 border border-gray-300 rounded-lg">
								<option selected>{agent?.settings?.selectedModel}</option>
							</select>
						</DetailCard>

					</div>


					<div className="w-2/4">
						<DetailCard title="How your AI agent should work" showLine={true}>
							<SubCard title="Instruction" subtitle="Describe the role and responsibilities of this agent. you can include examples of how it should respond to different types of tasks.">
								{agent?.settings?.namingInstructions &&
									<Content text={agent?.settings?.namingInstructions} />
								}
							</SubCard>
							<SubCard title="Flow Builder" subtitle="Use our worker flow builder to describe generally how your agent should make decision after receiving a task or message">
								<Button onClick={handleCloseDialog} size='sm' variant="default">View Workflow</Button>
							</SubCard>
						</DetailCard>
					</div>



					<div className="w-1/4">
						<DetailCard title="What your AI agent can do" showLine={true}>
							
							<SubCard title="SubAgents">
								{agent?.subAgents?.map((item: any, index: number) => {
									const agentsData = JSON.parse(item.raw_data);
									const config = genConfig(agentsData?.agentProfile?.title);
									return (
										<NameCard
											key={index}
											title={agentsData?.agentProfile?.title}
											description={agentsData?.agentProfile?.description}
											avatarConfig={config}
										/>
									)
								})}
							</SubCard>

							<SubCard title="Tools">
								{agent?.tools?.length > 0 ? (
									agent?.tools?.map((item: any, index: number) => {
										const tool = JSON.parse(item?.flowData);
										const config = genConfig(item?.id);
										return (
											<NameCard
												key={index}
												title={item?.tool_name}
												description={tool?.overview?.description || '...'}
												avatarConfig={config}
													
											/>
										)
									}))
									: (
										<div className="text-center py-4 text-gray-500">
											<p>No tools available.</p>
										</div>
									)}
							</SubCard>

							<SubCard title="Tags">
								{agent?.abilities?.map((tool: any, index: number) => (
									<TooltipProvider key={index}>
										<Tooltip delayDuration={200}>
											<TooltipTrigger>
												<Badge variant="outline" className="text-sm mr-2 mb-2 font-light">
													{tool?.title}
												</Badge>
											</TooltipTrigger>
											<TooltipContent className="bg-white text-gray-900 border border-gray-200">
												<p className="max-w-xs">{tool?.description}</p>
											</TooltipContent>
										</Tooltip>
									</TooltipProvider>
								))}
							</SubCard>

							<SubCard title="Configure Template">
								{agent?.inputData?.map((item: any) => (
									<div key={item.inputText}>
										<label className="text-sm font-bold text-slate-600">{item?.inputText} <span style={{ color: 'red' }}>*</span></label>
										<input type="text" value={item?.testValue} className="mt-1 block w-full p-2 text-sm text-gray-900 border border-gray-300 rounded-lg" />
									</div>
								))}
							</SubCard>

						</DetailCard>
					</div>
				</div>
			</div>
		</>
	)
}
